var _rect, _g, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInValidEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5500_35745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5500_35745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58975 16.25C3.16881 16.25 2.8125 16.1041 2.52084 15.8125C2.22917 15.5208 2.08334 15.1645 2.08334 14.7435V5.25642C2.08334 4.83547 2.22917 4.47917 2.52084 4.1875C2.8125 3.89583 3.16881 3.75 3.58975 3.75H16.4102C16.8312 3.75 17.1875 3.89583 17.4791 4.1875C17.7708 4.47917 17.9166 4.83547 17.9166 5.25642V14.7435C17.9166 15.1645 17.7708 15.5208 17.4791 15.8125C17.1875 16.1041 16.8312 16.25 16.4102 16.25H3.58975ZM9.99998 10.4647L3.33332 6.20187V14.7435C3.33332 14.8183 3.35736 14.8798 3.40544 14.9279C3.45352 14.9759 3.51496 15 3.58975 15H16.4102C16.485 15 16.5464 14.9759 16.5945 14.9279C16.6426 14.8798 16.6667 14.8183 16.6667 14.7435V6.20187L9.99998 10.4647ZM9.99998 9.16665L16.5384 4.99998H3.46152L9.99998 9.16665ZM3.33332 6.20187V4.99998V14.7435C3.33332 14.8183 3.35736 14.8798 3.40544 14.9279C3.45352 14.9759 3.51496 15 3.58975 15H3.33332V6.20187Z",
    fill: "#656E83"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.56L17.16 15.72C17.2333 15.7933 17.3267 15.83 17.44 15.83C17.5533 15.83 17.6467 15.7933 17.72 15.72C17.7933 15.6467 17.83 15.5533 17.83 15.44C17.83 15.3267 17.7933 15.2333 17.72 15.16L16.56 14L17.72 12.84C17.7933 12.7667 17.83 12.6733 17.83 12.56C17.83 12.4467 17.7933 12.3533 17.72 12.28C17.6467 12.2067 17.5533 12.17 17.44 12.17C17.3267 12.17 17.2333 12.2067 17.16 12.28L16 13.44L14.84 12.28C14.7667 12.2067 14.6733 12.17 14.56 12.17C14.4467 12.17 14.3533 12.2067 14.28 12.28C14.2067 12.3533 14.17 12.4467 14.17 12.56C14.17 12.6733 14.2067 12.7667 14.28 12.84L15.44 14L14.28 15.16C14.2067 15.2333 14.17 15.3267 14.17 15.44C14.17 15.5533 14.2067 15.6467 14.28 15.72C14.3533 15.7933 14.4467 15.83 14.56 15.83C14.6733 15.83 14.7667 15.7933 14.84 15.72L16 14.56ZM16 18C15.4467 18 14.9267 17.895 14.44 17.685C13.9533 17.475 13.53 17.19 13.17 16.83C12.81 16.47 12.525 16.0467 12.315 15.56C12.105 15.0733 12 14.5533 12 14C12 13.4467 12.105 12.9267 12.315 12.44C12.525 11.9533 12.81 11.53 13.17 11.17C13.53 10.81 13.9533 10.525 14.44 10.315C14.9267 10.105 15.4467 10 16 10C16.5533 10 17.0733 10.105 17.56 10.315C18.0467 10.525 18.47 10.81 18.83 11.17C19.19 11.53 19.475 11.9533 19.685 12.44C19.895 12.9267 20 13.4467 20 14C20 14.5533 19.895 15.0733 19.685 15.56C19.475 16.0467 19.19 16.47 18.83 16.83C18.47 17.19 18.0467 17.475 17.56 17.685C17.0733 17.895 16.5533 18 16 18Z",
    fill: "#FF453A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInValidEmail);
export default __webpack_public_path__ + "static/media/inValidEmail.1824412f09bad645f221ab25acf8dc74.svg";
export { ForwardRef as ReactComponent };